import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Checkmark = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <circle
          cx='12'
          cy='12'
          r='9'
          stroke='currentColor'
          strokeWidth='1.5'
          fill='none'
        />
        <path
          d='M14.6699 8.77539C14.9322 8.45481 15.404 8.40763 15.7246 8.66992C16.0452 8.93222 16.0924 9.40403 15.8301 9.72461L11.3301 15.2246C11.1959 15.3886 10.9987 15.4885 10.7871 15.499C10.5756 15.5095 10.3695 15.43 10.2197 15.2803L8.21973 13.2803C7.92683 12.9874 7.92683 12.5126 8.21973 12.2197C8.51262 11.9268 8.98738 11.9268 9.28027 12.2197L10.6943 13.6338L14.6699 8.77539Z'
          fill='currentColor'
        />
      </>
    ) : (
      <path
        d='M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.4746 8.91992C15.154 8.65763 14.6822 8.70481 14.4199 9.02539L10.4443 13.8838L9.03027 12.4697C8.73738 12.1768 8.26262 12.1768 7.96973 12.4697C7.67683 12.7626 7.67683 13.2374 7.96973 13.5303L9.96973 15.5303C10.1195 15.68 10.3256 15.7595 10.5371 15.749C10.7487 15.7385 10.9459 15.6386 11.0801 15.4746L15.5801 9.97461C15.8424 9.65403 15.7952 9.18222 15.4746 8.91992Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
